import storage from './storage';

const K = 'crm_table_density';

export function getTableDensity() {
  const v = storage.get(K, 'comfortable');
  return v === 'compact' ? 'compact' : 'comfortable';
}

export function setTableDensity(mode) {
  const v = mode === 'compact' ? 'compact' : 'comfortable';
  storage.set(K, v);
  try {
    window.dispatchEvent(new CustomEvent('crm-table-density'));
  } catch { /* ignore */ }
}
